import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Module, Answer, AccordionToggle } from 'components/misc'
import { apiProfileQuestions } from 'helpers/decorators/api'
import { CircleLoader } from 'components/loaders'

import styles from './participant-profile-questions.styl'

@apiProfileQuestions({
  participantAnswers: true
})
class ParticipantProfileQuestions extends Component {
  static propTypes = {
    profileQuestions: PropTypes.object.isRequired,
    onGetParticipantsAnswers: PropTypes.func.isRequired,
    awardId: PropTypes.number
  }

  state = { isVisible: false, loaded: false }

  handleToggle = () => {
    if (!this.state.loaded) {
      this.props.onGetParticipantsAnswers(this.props.awardId)
      this.setState({ loaded:true })
    }

    this.setState({ isVisible: !this.state.isVisible })
  }

  render() {
    const { profileQuestions } = this.props
    const hasAnswers = profileQuestions.participantAnswers.length > 0
    const isLoading = profileQuestions.loading

    return (
      <Module narrow verticallyNarrow>
        <AccordionToggle
          isActive={this.state.isVisible}
          onClick={this.handleToggle}
          intlKey="moduleTitle.profile_questions"
        >
          Profile questions
        </AccordionToggle>
        {this.state.isVisible && (
          <div className={styles.wrap}>
            {isLoading && <CircleLoader size={60} />}
            {!isLoading &&
              hasAnswers &&
              profileQuestions.participantAnswers.map(item => (
                <Answer key={item.id} item={item} />
              ))}
            {!isLoading &&
              !hasAnswers && (
                <FormattedMessage
                  id="label.no_answers"
                  defaultMessage="No answers"
                />
              )}
          </div>
        )}
      </Module>
    )
  }
}

export default ParticipantProfileQuestions
